import {
  Box,
  Button,
  Paper,
  CircularProgress,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import { PutAPI } from "../../Components/Backend/PutAPI";
import { useMemo, useState } from "react";
import "@react-pdf-viewer/core/lib/styles/index.css";      
import "@react-pdf-viewer/toolbar/lib/styles/index.css";   
import APIAxios from "../../Api/APIAxios";
import SessaoAuth from "../../Hooks/SessaoAuth";
import workerUrl from "pdfjs-dist/build/pdf.worker.min.js?url";
import { set } from "lodash";

const ACEITE_URL = "/aceite";

const TermoAceite = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const { setSessao } = SessaoAuth();
  const apiAxios = APIAxios();
  const navigate = useNavigate();

  const handleAceitar = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);
      const response = await PutAPI(apiAxios, ACEITE_URL);
      setLoading(false);

      if (response.success) {
        
        setSessao((prev) => ({
          ...prev,
          datAceite:
            response?.data?.datAceite === "" ? null : response?.data?.datAceite,
        }));

        navigate("/home");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSair = () => {
    navigate("/login");
  };

  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        maxWidth: 1100,
        mx: "auto",
      }}
    >
      {/* CARD PRINCIPAL */}
      <Paper
        elevation={3}
        sx={{
          mt: 0,
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        {/* HEADER DO CARD COM TOOLBAR */}
        <Box
          sx={{
            px: { xs: 2, md: 3 },
            py: 1.5,
            bgcolor: "rgba(26,56,101,0.06)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box sx={{ fontWeight: 600, color: "#1a3865" }}>
            Leia o documento e, se estiver de acordo, confirme seu aceite. Caso contrário, selecione SAIR.
          </Box>

        </Box>

        <Divider />

        {/* ÁREA DO PDF */}
        <Box
          sx={{
            position: "relative",
            px: { xs: 1, md: 2 },
            py: { xs: 1, md: 2 },
            bgcolor: "#fff",
          }}
        >
          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              overflow: "hidden",
              // Altura responsiva da área de visualização
              height: { xs: "50vh", md: "50vh" },
              // Sombra leve
              boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.02)",
            }}
          >
            <Worker workerUrl={workerUrl}>
              <Viewer
                fileUrl="/termoaceite.pdf"
              />
            </Worker>
          </Box>

          {/* Overlay de loading ao aceitar */}
          {loading && (
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                bgcolor: "rgba(255,255,255,0.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2,
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Box>

        <Divider />

        {/* AÇÕES */}
        <Box
          sx={{
            px: { xs: 2, md: 3 },
            py: 2,
            display: "flex",
            gap: 2,
            justifyContent: "flex-end",
            bgcolor: "background.paper",
          }}
        >
          <Button
            variant="outlined"
            size="large"
            onClick={handleSair}
            sx={{
              borderColor: "#1a3865",
              color: "#1a3865",
              "&:hover": { borderColor: "#122742", color: "#122742" },
            }}
          >
            Sair
          </Button>

          <Button
            variant="contained"
            size="large"
            onClick={handleAceitar}
            disabled={loading}
            sx={{
              bgcolor: "#1a3865",
              "&:hover": { bgcolor: "#122742" },
            }}
          >
            Aceitar
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default TermoAceite;
